import { Box } from "@mui/material";
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { memo, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectorLightLogos } from "../../store/slices/configSlice";
import Utils from "../../../utils/Utils";

const Image = ({
  children,
  view = false,
  size = "lg",
  ImgProps = {},
  BoxProps = {},
}) => {
  const { className: imgClass, src, ...imgRest } = ImgProps || {};
  const { className: boxClass, ...boxRest } = BoxProps || {};

  const [loading, setLoading] = useState(true);
  const logos = useSelector(selectorLightLogos);

  const placeholder = useMemo(
    () => logos?.vertical_logo,
    [logos?.vertical_logo]
  );

  const picture = useMemo(() => {
    if (!src) return null;
    return String(src).includes("?") ? `${src}&s=${size}` : `${src}?s=${size}`;
  }, [src, size]);

  if (!picture) return null;

  const handleClick = () => {
    try {
      if (!view) return;

      window.open(src, "_blank");
    } catch (error) {}
  };

  const onLoad = (e) => setLoading(false);

  return (
    <Box
      {...boxRest}
      className={clsx(
        "w-full h-full relative overflow-hidden bg-white",
        boxClass
      )}
    >
      <AnimatePresence>
        {loading && (
          <motion.div
            key="loader"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className={clsx("w-full h-full absolute top-0 left-0 z-99")}
          >
            <img
              src={placeholder}
              alt={"Placeholder"}
              className={clsx(
                "w-full h-full object-contain !p-40 opacity-30 z-99"
              )}
              draggable="false"
              onMouseDown={(e) => e.preventDefault()}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.img
        {...imgRest}
        src={picture}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={
          !loading ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }
        }
        transition={{ duration: 0.6, ease: "easeOut" }}
        className={clsx(
          "!w-full !h-full !object-contain",
          view && "hover:cursor-pointer hover:opacity-40",
          imgClass
        )}
        onLoad={onLoad}
        onClick={handleClick}
        draggable="false"
      />

      {children}
    </Box>
  );
};

export default memo(Image);
